import React from 'react';
import { useNavigate } from 'react-router';
import { useTranslate } from '../../../mixins/translate/translate';
import { openApiFetchGet } from '../../../store/openApiFetch';
import { PanelBody, Table, TableBody, TableData, TableHead, TableHeader, TableHeadRow, TableRow } from '../../elements';
import { Spinner } from '../../spinners';
import { EquipmentExpirationLabel } from '../../utils/equipmentExpirationLabel';
import { useReactAsync } from '../../utils/useReactAsync';

async function loadEquipmentCarrier({ equipmentId }: { equipmentId: string }) {
    const result = await openApiFetchGet('/api/equipmentCarrier', { equipmentId });
    return result;
}

export function EquipmentCarrierList(props: { equipmentId: string }) {
    const translate = useTranslate();
    const navigate = useNavigate();
    const { data, isLoading } = useReactAsync(loadEquipmentCarrier, { equipmentId: props.equipmentId }, [props.equipmentId]);

    return (
        <>
            {(isLoading && <Spinner />) || (
                <PanelBody noPadding>
                    <Table hover>
                        <TableHead>
                            <TableHeadRow light={true}>
                                <TableHeader>{translate('common.name')}</TableHeader>
                                <TableHeader>{translate('common.status')}</TableHeader>
                                <TableHeader align="right">{translate('equipment.expirationDate')}</TableHeader>
                            </TableHeadRow>
                        </TableHead>
                        <TableBody>
                            {data &&
                                data.map((item) => (
                                    <TableRow key={item.equipmentCarrier.id} onClick={() => navigate(`/equipment/${item.equipmentCarrier.id}`)}>
                                        <TableData> {item.equipmentCarrier.name} </TableData>
                                        <TableData> {translate(`equipment.${item.equipmentCarrier.status}`)}</TableData>
                                        <TableData alignRight>
                                            {' '}
                                            <EquipmentExpirationLabel data={item.equipmentCarrier} />
                                        </TableData>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                </PanelBody>
            )}
        </>
    );
}
